const APP_CONFIG = {
  FRONTEND_VERSION: 43,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
